import { Dispatch, SetStateAction } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { Source } from 'modules/core/components/ActivityLog/Log/types'
import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

interface Props {
  filteredSources?: Source
  value: string[]
  setSources: Dispatch<SetStateAction<string[]>>
}

export const LogFilter = ({ filteredSources, value, setSources }: Props) => {
  const filterOptions = () => {
    if (!filteredSources) return []

    return (
      Object.entries(filteredSources).map((filteredSource) => {
        return {
          label: filteredSource[1].title,
          value: filteredSource[1].key,
        }
      }) || []
    )
  }

  return (
    <Box flexDirection="row" paddingX="s24" paddingY="s8" data-testid="log-filter">
      <Filter.MultipleChoice
        label={
          value.length ? i18n.t('activity_log.filters.update') : i18n.t('activity_log.filters.all')
        }
        options={filterOptions()}
        value={value}
        onValueChange={(selectedSources) => {
          setSources(selectedSources || [])
        }}
      />
    </Box>
  )
}
